var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shipping-schedule-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title:
              this.$t("SeaExport.SailingDate") + _vm.$t("SeaExport.Select"),
            width: "1240px",
            "show-close": true,
            "close-on-click-modal": false,
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("tab-shippping-schedule", {
            ref: "tabShipppingSchedule",
            on: { callback: _vm.callback }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }